/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export default function Button({ title, handlerClick, disabled = false }): JSX.Element {
    return (
        <button
            disabled={disabled}
            className={`contact-button rounded-full uppercase py-4 font-extrabold  ${
                disabled ? 'bg-gray-200 text-sm-integrate' : 'bg-sm-integrate text-white'
            }`}
            type="submit"
            onClick={handlerClick}
        >
            {title}
        </button>
    );
}
